// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"4ba911d452a4837c","6831":"74a2ef4106ed072d","8503":"8ef8eddd6c0106ad","9683":"1f2512835d2442ae"}[chunkId] + ".js";
};